import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";
import moment from "moment";
import Modal from "react-modal";
import numberToWords from "number-to-words";

import { toast } from "react-toastify";

const GoodsReturnForm = (props) => {
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "10%",
      left: "25%",
      borderRadius: "5px",
      maxWidth: "900px",
      maxHeight: "auto",
      height: "500px",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );
  const [discountPr, setDiscountPr] = useState(0);
  const [totalAmt, setTotalAmt] = useState(0);
  const [discountAmt, setDiscountAmt] = useState(0);

  const [grId, setGrId] = useState();
  const [poId, setPoId] = useState();
  const [costInWords, setCostInWords] = useState(0);

  const [vendorId, setVendorId] = useState(0);

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);

  const currentDate = new Date().toISOString().slice(0, 10);

  const frmRef = useRef({});
  const { sendRequest: postGoodsReturn } = useHttp();

  const productRef = useRef({});
  const [productDetails, setProductDetails] = useState([]);
  const [close, setClose] = useState(false);
  const [goodReceipt, setGoodReceipt] = useState([]);
  const [goodsReturnRecieptId, setGoodsReturnRecieptId] = useState(false);
  const [docurl, setDocUrl] = useState(false);
  const [subTotalAmount, setSubTotal] = useState(0);
  const [selectedId, setSelectedId] = useState(0);
  const [taxs, setTaxs] = useState([]);
  const [currancys, setCurrancys] = useState();

  const [taxAmount, setTaxAmount] = useState(0);
  const [taxId, setTaxId] = useState(1);

  const [frieghtCharges, setfrieghtCharges] = useState(0);
  const [totalCostValue, setTotalCostValue] = useState(0);

  const [totals, setTotals] = useState({});

  const [loading, setLoading] = useState(false);

  const { sendRequest: getGoodsReceipt } = useHttp();

  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        setEmployeeData(data.output);
      }
    );
  }, [getEmp]);

  const { sendRequest: getGoodsReceiptId } = useHttp();
  const { sendRequest: getTaxs } = useHttp();
  const { sendRequest: getCurrency } = useHttp();

  useEffect(() => {
    getCurrency(
      {
        url: `/api/currencies/`,
      },
      (res) => {
        if (res) {
          setCurrancys(res);
        }
      }
    );
  }, [getCurrency]);

  useEffect(() => {
    getTaxs(
      {
        url: `/api/tax/`,
      },
      (res) => {
        if (res) {
          // //console.log(res);
          setTaxs(res);
        }
      }
    );
  }, [getTaxs]);

  useEffect(() => {
    getGoodsReceipt(
      {
        url: `/api/goodsReciept/?orgId=${localStorage.getItem(
          "orgId"
        )}&goodrecipt=${true}`,
      },
      (res) => {
        if (res) {
          setGoodReceipt(res);
        }
      }
    );
  }, [getGoodsReceipt]);

  const submitHandler = (e) => {
    e.preventDefault();

    var taxId = frmRef.current.tax.value;
    var taxPercentage = 0;
    if (taxId != "Select Tax") {
      var selectedTax = taxs.filter((item) => item.taxId == taxId);
      taxPercentage = selectedTax && selectedTax[0].taxPercentage;
    }
    var ik = 0;
    productDetails.forEach((item) => {
      var newLineAmount = totals[ik];

      ik++;
      var stockAmount = 0;
      stockAmount = newLineAmount;
      console.log("stockAmount", stockAmount);
      console.log("discountPr", discountPr);

      if (parseFloat(discountPr) > 0) {
        var linedisAmount = (stockAmount * parseFloat(discountPr)) / 100;
        linedisAmount = linedisAmount.toFixed(2);
        console.log("linedisAmount", linedisAmount);

        stockAmount = (stockAmount - linedisAmount).toFixed(2);
      }

      if (parseFloat(taxPercentage) > 0) {
        var linetaxamount = (stockAmount * parseFloat(taxPercentage)) / 100;
        linetaxamount = linetaxamount.toFixed(2);
        //  //console.log("linetaxamount", linetaxamount);

        stockAmount = parseFloat(stockAmount) + parseFloat(linetaxamount);
      }
      item["stockAmount"] = stockAmount;
      item["lineAmount"] = newLineAmount;
      //console.log("stockAmount", stockAmount);
    });

    setLoading(true);

    const data = {
      goodsReturnDate: moment(frmRef.current.date.value).format("DD/MM/YYYY"),
      goodRecieptDate: moment(frmRef.current.receipt_date.value).format(
        "DD/MM/YYYY"
      ),
      goodsReceiptId: frmRef.current.goods_receipt_id.value,

      vendorId: vendorId,
      supervisorEmployeeId: employeeId,
      productDetails: productDetails,
      lineTotalAmount: subTotalAmount,
      totalAmount: frmRef.current.total_amt.value,
      currencyId: frmRef.current.currency.value,
      freightCharges: frieghtCharges,
      discountPercentage: discountPr,
      discountAmount: (discountPr * subTotalAmount) / 100,
      taxId: frmRef.current.tax.value,
      taxAmount: parseFloat(frmRef.current.tax_amt.value).toFixed(2),
      totalPurchaseAmount: parseFloat(frmRef.current.total_cost.value).toFixed(
        2
      ),
      amountChargeable: frmRef.current.amt_chargeable.value,
      itemCondition: frmRef.current.condition.value,
      returnReason: frmRef.current.reason.value,
      remark: frmRef.current.remark.value,
      // purchaseInvoiceId: 10,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
      status: 1,
      serviceId: props.sId,
    };
    //console.log( "Return",data);
    if (props.update) {
      setGoodsReturnRecieptId(props.update.goodsReturnRecieptId);
      data["goodsReturnRecieptId"] = props.update.goodsReturnRecieptId;
    }

    postGoodsReturn(
      {
        url: "/api/goodsReturnReciept/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (res) => {
        toast.success(`Goods Return  ${props.update ? "Updated" : "Added"}`);
        props.addForm(false);
        setGoodsReturnRecieptId(res.goodsReturnRecieptId);
        setLoading(false);
      },
      (error) => {
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );
  };
  useEffect(() => {
    if (props.update) {
      frmRef.current.date.value = props.update.Date.split("/")
        .reverse()
        .join("-");
      frmRef.current.receipt_date.value = props.update.goodRecieptDate
        .split("/")
        .reverse()
        .join("-");
      frmRef.current.goods_receipt_id.value = props.update.goodsRecieptId;
      frmRef.current.contact_person_name.value = props.update.contactPersonName;
      frmRef.current.work_contact.value = props.update.contactWork;
      frmRef.current.whatsapp_contact.value = props.update.whatsapp;
      frmRef.current.email.value = props.update.email;
      frmRef.current.vendor_name.value = props.update.vendorName;
      setVendorId(props.update.vendorId);
      frmRef.current.total_amt.value = props.update.totalAmount;

      frmRef.current.tax.value = props.update.tax;
      frmRef.current.tax_amt.value = props.update.taxAmount;
      frmRef.current.total_cost.value = props.update.totalPurchase;
      frmRef.current.amt_chargeable.value = props.update.amountChargeable;
      frmRef.current.remark.value = props.update.remark;
      frmRef.current.condition.text = props.update.itemCondition;
      frmRef.current.reason.value = props.update.returnReason;
      setProductDetails(props.update.productDetails);
      setGoodsReturnRecieptId(props.update.goodsReturnRecieptId);
    }
  }, [props.update]);

  useEffect(() => {
    if (close) {
      setTotalValue();
    }
  }, [selectedId]);

  const setTotalValue = () => {
    let acc = 0;
    productDetails.forEach((x) => {
      acc += x.rate * x.goodsReceiptQuantity;
    });

    setSubTotal(acc);
    var disamt = (discountPr * acc) / 100;
    setDiscountAmt((discountPr * acc) / 100);
    setTotalAmt(parseFloat(acc - disamt).toFixed(2));
  };

  const handleGoodReceipt = (e) => {
    e.preventDefault();
    var Id = 0;
    if (e.target.value != "Select") {
      Id = e.target.value;
    }
    setSelectedId(Id);

    var goodReceiptsortrd = goodReceipt.filter(
      (item) => item.goodsReceiptId == Id
    );

    var goodReceiptItem = goodReceiptsortrd && goodReceiptsortrd[0];

    loadVendorData(goodReceiptItem.vendorId);

    frmRef.current.receipt_date.value = goodReceiptItem.goodsReceiptDate;

    frmRef.current.tax.value = goodReceiptItem.taxId;
    setTaxAmount(0);
    setTotalCostValue(0);
    setfrieghtCharges(0);

    frmRef.current.amt_chargeable.value = "";
    frmRef.current.remark.value = goodReceiptItem.remark;

    setGrId(goodReceiptItem.goodsReceiptId);
    setPoId(goodReceiptItem.purchaseorderId);

    setTotalAmt(
      parseFloat(goodReceiptItem.lineTotalAmount).toFixed(2) -
        parseFloat(goodReceiptItem.discountAmount).toFixed(2)
    );

    setDiscountAmt(0);

    setDiscountPr(goodReceiptItem.discountPercentage);
    setSubTotal(0);

    // productRef.current.subTotalAmount.value = 0;
  };
  useEffect(() => {
    getGoodsReceiptId(
      {
        url: `/api/GoodsReceiptProductForGoodsReturn/?orgId=${localStorage.getItem(
          "orgId"
        )}&goodsReceiptId=${selectedId}`,
      },
      (res) => {
        // console.log(res.output);
        setProductDetails(res.output);
      }

      //}
    );
  }, [selectedId]);

  const { sendRequest: getLoadVendor } = useHttp();

  const loadVendorData = (id) => {
    getLoadVendor(
      {
        url: `/api/addVendor/?vendorId=${id}`,
      },
      (res) => {
        if (res) {
          setVendorId(res.vendorId);
          frmRef.current.vendor_name.value = res.vendorName || "";
          frmRef.current.contact_person_name.value =
            res.contactPersonName || "";
          frmRef.current.work_contact.value = res.contactWork || "";
          frmRef.current.whatsapp_contact.value = res.whatsapp || "";
          frmRef.current.email.value = res.email || "";
        }
      }
    );
  };

  const viewPdf = (e) => {
    e.preventDefault();
    setDocUrl("https://www.orimi.com/pdf-test.pdf");
  };

  const handleTaxChange = (e) => {
    setTaxId(e.target.value);
    // //console.log(e.target.value);
  };
  useEffect(() => {
    const filteredTaxPer =
      taxs &&
      taxs
        .filter((item) => parseInt(item.taxId) === parseInt(taxId))
        .map((item) => item.taxPercentage);

    const taxAmt =
      (parseFloat(totalAmt).toFixed(2) / 100) * parseFloat(filteredTaxPer) || 0;

    //console.log(totalAmt);

    setTaxAmount(parseFloat(taxAmt).toFixed(2));
  }, [taxId, totalAmt]);

  useEffect(() => {
    const tCost =
      parseFloat(totalAmt) + parseFloat(taxAmount) + parseFloat(frieghtCharges);
    setTotalCostValue(parseFloat(tCost).toFixed(2));
  }, [totalAmt, taxAmount, frieghtCharges, taxId]);

  const handleQuantityChange = (index, event) => {
    const value = parseInt(event.target.value);

    const goodsReceiptQuantity = productDetails[index].avlQuantity;

    if (value > goodsReceiptQuantity) {
      toast.success(
        "Balance Quantity cannot be greater than Goods Receipt Quantity"
      );

      return;
    } else {
      const newTotals = { ...totals };
      const quantity = Number(event.target.value);

      const rate = productDetails[index].rate;

      const total = isNaN(quantity) ? 0 : quantity * rate;
      newTotals[index] = total;
      setTotals(newTotals);

      const updatedProductDetails =
        productDetails &&
        productDetails.map((item, i) => {
          return {
            ...item,
            goodsReturnQuantity:
              i === index ? quantity : item.goodsReturnQuantity,
            availableQuantity: i === index ? quantity : item.avlQuantity,
          };
        });

      setProductDetails(updatedProductDetails);
    }
  };

  useEffect(() => {
    const newSubtotal = Object.values(totals).reduce(
      (accumulator, currentValue) => {
        return accumulator + currentValue;
      },
      0
    );

    //  console.log(newSubtotal);

    setSubTotal(newSubtotal);
  }, [totals]);

  useEffect(() => {
    const dis = (discountPr * subTotalAmount) / 100 || 0;

    setDiscountAmt(dis);

    if (dis < 0) {
      setDiscountAmt(0);
    }
    setTotalAmt(
      parseFloat(subTotalAmount).toFixed(2) - parseFloat(dis).toFixed(2)
    );
  }, [subTotalAmount]);

  const convertFloatToWords = (number) => {
    const words = numberToWords.toWords(number);
    const wordArray = words.split(" ");
    const decimalPart = Math.round(number * 100) % 100;
    if (decimalPart > 0) {
      const decimalWords = numberToWords.toWords(decimalPart);
      wordArray.push("and");
      wordArray.push(decimalWords);
    }

    return wordArray.join(" ");
  };

  useEffect(() => {
    const totalCost1 = totalCostValue || 0;
    const totalCostInWords = convertFloatToWords(totalCost1);
    // console.log(totalCost1);
    setCostInWords(totalCostInWords);
  }, [totalCostValue]);

  return (
    <>
      {close && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">Product Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>

          <table className="table table-responsive table-bordered ">
            <thead>
              <tr className="">
                <th>Sr.No</th>
                <th>Item Category</th>
                <th>Item Description</th>
                <th>Item Type</th>
                <th>Item Unit Price</th>
                <th>Rate</th>
                <th>Receipt Quantity</th>
                <th>Return Quantity</th>
                <th>Unit</th>
                <th>Amount</th>
              </tr>
            </thead>

            <tbody>
              {productDetails &&
                productDetails.map((itm, i) => {
                  return (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>{itm.productTypeName}</td>
                      <td>{itm.productSubTypeName}</td>
                      <td>{itm.productName}</td>
                      <td>{itm.itemUnitPrice}</td>
                      <td>{itm.rate}</td>
                      <td>{itm.avlQuantity}</td>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          value={itm.goodsReturnQuantity}
                          ref={(el) => (productRef.current["qtyBal"] = el)}
                          onChange={(event) => handleQuantityChange(i, event)}
                        />
                      </td>
                      <td>{itm.unitAbbreviation}</td>
                      <td>{totals[i] || 0}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>

          <hr />
          <div className="row mb-2">
            <div className="col-md-3">
              <label htmlFor={"subTotalAmount"}>Sub-total Amount</label>
              <input
                type={"number"}
                id={"subTotalAmount"}
                value={subTotalAmount}
                ref={(el) => (productRef.current["subTotalAmount"] = el)}
                className="form-control"
                disabled
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"discount"}>Discount%</label>
              <input
                type={"number"}
                id={"discount"}
                required
                value={discountPr}
                ref={(el) => (productRef.current["discount"] = el)}
                className="form-control"
                disabled
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"discountAmount"}>Discount Amount</label>
              <input
                type={"number"}
                id={"discountAmount"}
                required
                disabledd
                ref={(el) => (productRef.current["discountAmount"] = el)}
                className="form-control"
                disabled
                value={discountAmt}
              />
            </div>

            <div className="col-md-3">
              <label htmlFor={"totalAmount"}>Total Amount</label>
              <input
                type={"input"}
                id={"totalAmount"}
                required
                disabledd
                ref={(el) => (productRef.current["totalAmount"] = el)}
                className="form-control"
                disabled
                value={totalAmt}
              />
            </div>
          </div>
          <div className="text-center">
            <button
              className="btn btn-sm btn-primary"
              onClick={(e) => {
                const updatedProductDetails = productDetails.map((item, i) => {
                  return {
                    ...item,
                    isSave: true,
                    linesrno: i,
                    // goodsReturnQuantity: item.qtyBal,
                    createdBy: parseInt(localStorage.getItem("id")),
                  };
                });
                // //console.log(updatedProductDetails);
                setProductDetails(updatedProductDetails);
                setClose(false);
              }}
            >
              Save
            </button>
          </div>
        </Modal>
      )}

      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">&nbsp;
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Goods Return Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"date"}> {"Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"vendor_name"}>
                        {" "}
                        {"Assign Employee"}
                      </label>
                      <select
                        id="emp_id"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["emp_id"] = el)}
                        value={employeeId}
                        required
                        onChange={(e) => {
                          setEmployeeId(e.target.value);
                        }}
                      >
                        {/* {employeeId &&
                    employeeId.map((x) => <option value={x}>{x}</option>)}
                */}
                        <option selected value="">
                          --Select Employee--
                        </option>
                        {employeeData &&
                          employeeData.map((x) => (
                            <option
                              key={x.empId}
                              employee-id={x.empId}
                              value={x.empId}
                              selected={
                                props.update &&
                                x.empId === props.update.supervisorEmployeeId
                              }
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"goods_receipt_id"}>
                        {"Goods Receipt No"}
                      </label>
                      <select
                        id="goods_receipt_id"
                        className="form-control dropdowns"
                        onChange={handleGoodReceipt}
                        ref={(el) => (frmRef.current["goods_receipt_id"] = el)}
                      >
                        <option selected disabled value="">
                          Select
                        </option>
                        {goodReceipt &&
                          goodReceipt.map((x, i) => (
                            <option key={i} value={x.goodsReceiptId}>
                              {x.docNo}
                            </option>
                          ))}
                      </select>
                    </div>

                    {/* <label htmlFor={"purchase_order_id"}>
              {" "}
              {"poId - "}
              {poId}
            </label> */}
                    <div className="col-md-3">
                      <label htmlFor={"receipt_date"}>
                        {" "}
                        {"Goods Receipt Date"}
                      </label>
                      <input
                        type={"text"}
                        id={"receipt_date"}
                        disabled
                        required
                        ref={(el) => (frmRef.current["receipt_date"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"vendor_name"}> {"Vendor Name"}</label>
                      <input
                        id="vendor_name"
                        disabled
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["vendor_name"] = el)}
                      />

                      {/*               
              <label htmlFor={"vendor_id"}> {"Vendor id"}</label>
              <input
                type={"text"}
                id={"vendor_id"}
                required
                disabled
                ref={(el) => (frmRef.current["vendor_id"] = el)}
                className="form-control"
              /> */}
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"contact_person_name"}>
                        {"Contact Person Name"}
                      </label>
                      <input
                        type={"text"}
                        id={"contact_person_name"}
                        required
                        ref={(el) =>
                          (frmRef.current["contact_person_name"] = el)
                        }
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"email"}> {"Email Id"}</label>
                      <input
                        type={"email"}
                        id={"email"}
                        required
                        ref={(el) => (frmRef.current["email"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"work_contact"}>
                        {"Contact Number(work)"}
                      </label>
                      <input
                        type={"text"}
                        id={"work_contact"}
                        required
                        ref={(el) => (frmRef.current["work_contact"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"whatsapp_contact"}>
                        {"Contact Number(whatsapp)"}
                      </label>
                      <input
                        type={"text"}
                        id={"whatsapp_contact"}
                        required
                        ref={(el) => (frmRef.current["whatsapp_contact"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"product_details"}>
                        {" "}
                        {"Product Details"}
                      </label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        type={"button"}
                        id={"product_details"}
                        autoComplete="off"
                        onClick={() => {
                          productDetails &&
                            setProductDetails((items) =>
                              items.filter(
                                (x) => x.isSave || x.goodsReceiptDetailId
                              )
                            );
                          setClose(true);
                        }}
                        ref={(el) => (frmRef.current["product_details"] = el)}
                        className="btn btn-sm btn-success"
                      >
                        Add
                      </button>
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"total_amt"}>{"Total Amount"}</label>
                      <input
                        type={"text"}
                        id={"total_amt"}
                        required
                        ref={(el) => (frmRef.current["total_amt"] = el)}
                        className="form-control"
                        value={totalAmt}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"tax"}> {"Tax"}</label>
                      <select
                        id="tax"
                        required
                        disabled
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["tax"] = el)}
                        onChange={handleTaxChange}
                      >
                        <option value="">Select</option>
                        {taxs &&
                          taxs.map((x) => (
                            <option key={x.taxId} value={x.taxId}>
                              {x.taxName}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"tax_amt"}>{"Tax Amount"}</label>
                      <input
                        type={"text"}
                        id={"tax_amt"}
                        required
                        ref={(el) => (frmRef.current["tax_amt"] = el)}
                        className="form-control"
                        value={taxAmount}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"frieght_charges"}>
                        {"Frieght Charges"}
                      </label>
                      <input
                        type={"number"}
                        id={"frieght_charges"}
                        required
                   
                        value={frieghtCharges}
                        onChange={(e) => setfrieghtCharges(e.target.value || 0)}
                        className="form-control currancy-value"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"currency"}> {"Currency"}</label>
                      <select
                        id="currency"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["currency"] = el)}
                        disabled
                      >
                        {currancys &&
                          currancys.map((x) => (
                            <option key={x.currencyId} value={x.currencyId}>
                              {x.country.currencyName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"total_cost"}>
                        {"Total Purchase Cost/Value"}
                      </label>
                      <input
                        type={"text"}
                        id={"total_cost"}
                        required
                        ref={(el) => (frmRef.current["total_cost"] = el)}
                        className="form-control"
                        value={totalCostValue}
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"amt_chargeable"}>
                        {" "}
                        {"Amount Chargeable"}
                      </label>
                      <input
                        type={"text"}
                        id={"amt_chargeable"}
                        required
                        ref={(el) => (frmRef.current["amt_chargeable"] = el)}
                        className="form-control"
                        value={costInWords}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"condition"}>
                        {" "}
                        {"Condition of Item"}
                      </label>
                      <select
                        id="condition"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["condition"] = el)}
                      >
                        <option value="Good">Good</option>
                        <option value="Moderate">Moderate</option>
                        <option value="Bad">Bad</option>
                        <option value="Very Bad">Very Bad</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"reason"}>{"Reason of Return"}</label>
                      <input
                        type={"text"}
                        id={"reason"}
                        required
                        ref={(el) => (frmRef.current["reason"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        required
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className=" text-right">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default GoodsReturnForm;
